/** Never shrink the preview below this, even on a short landscape phone. */
export const MIN_PREVIEW_HEIGHT = 240;

/**
 * Share of the visible viewport the preview may occupy. The remainder keeps the
 * first controls in view on a phone, so editing does not mean scrolling blind.
 */
export const PREVIEW_VIEWPORT_RATIO = 0.66;

/**
 * Height budget for the preview canvas. On a desktop the caller's `maxHeight`
 * wins; on a phone — especially for a 9:16 cover, which is 1.8x taller than it
 * is wide — the viewport wins, so the whole thumbnail stays on screen.
 */
export function fitPreviewHeight(viewportHeight: number, maxHeight: number): number {
  if (!Number.isFinite(viewportHeight) || viewportHeight <= 0) return maxHeight;
  const budget = viewportHeight * PREVIEW_VIEWPORT_RATIO;
  return Math.min(maxHeight, Math.max(MIN_PREVIEW_HEIGHT, budget));
}

/**
 * The height the browser can actually show. `visualViewport` accounts for the
 * mobile URL bar and the on-screen keyboard, which `innerHeight` does not.
 */
export function readViewportHeight(): number {
  if (typeof window === 'undefined') return 0;
  return window.visualViewport?.height ?? window.innerHeight;
}
